
import React, { useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
import ExhibitionTypeList from './ExhibitionTypeList';
import ExhibitionTypeModal from './ExhibitionTypeModal';
import { ExhibitionType } from './types';

const ExhibitionTypeContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ExhibitionType | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const handleOpenAdd = () => {
    setSelectedItem(null);
    setModalOpen(true);
  };

  const handleOpenEdit = (item: ExhibitionType) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleSuccess = () => {
    setModalOpen(false);
    setRefreshTrigger(prev => !prev); 
  };

  return (
    <>
      <Breadcrumbs mainTitle="Exhibition Types" parent="Core Settings" />
      <Container fluid>
        <Row>
          <Col md="12">
            <ExhibitionTypeList
              onAdd={handleOpenAdd}
              onEdit={handleOpenEdit}
              refresh={refreshTrigger}
            />
          </Col>
        </Row>
        <ExhibitionTypeModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          onSuccess={handleSuccess}
          initialData={selectedItem}
        />
      </Container>
    </>
  );
};

export default ExhibitionTypeContainer;
